import CardView from "../../../../../components/common/CardView";
import {
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import FileUpload from "../../../../../components/common/FileUpload";
import BaseFormPage from "../../../../../base/BaseFormPage";
import {
  FloatingForm,
  SubmitImg,
} from "../../../../../components/common/Converter";
import InputFactory from "../../../../../components/InputFactory";
import { createNotification } from "../../../../../createNotification";
import SearchSelect from "../../../../../components/searchSelect/SearchSelect";
export default class ModernizationForm extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      type: [],
      selectedType: "",
      selectedFiles: [],
      inputCredit: "",
      remarks: "",
      objectID: "",
    };
  }

  async componentDidMount() {
    const type = await findObjectUseCase().execute("leave_type", {
      where: { is_monetized: true },
    });
    this.setState({ type });

    if (Object.keys(this.props.object).length > 0) {
      this.setState({
        selectedType: this.props.object.selectedType,
        inputCredit: this.props.object.inputCredit,
        remarks: this.props.object.remarks,
        selectedFiles: this.props.object.selectedFiles || [],
        objectID: this.props.object.id,
      });
    }
  }

  onChangeForm(field, value) {
    if (field === "startdate" || field === "enddate") {
      const startDate = field === "startdate" ? value : this.state.startdate;
      const endDate = field === "enddate" ? value : this.state.enddate;

      if (new Date(startDate) > new Date(endDate)) {
        this.showError("End Date should be greater than Start Date");
        return;
      } else {
        this.setState({ [field]: value });
      }
    }
    this.setState({ [field]: value });
  }

  checkBox(field) {
    this.setState((prevState) => ({
      [field]: !prevState[field],
    }));
  }

  async hanldeSubmit() {
    const { selectedType, selectedFiles, inputCredit, remarks } = this.state;
    const currentUser = this.getCurrentUser();

    const allEmp = await findObjectUseCase().execute("employees", {
      where: { id: currentUser.employee.id },
    });
    const noSupervisorAssigned = allEmp.every((emp) => !emp.supervisor);
    if (noSupervisorAssigned) {
      this.showError("No Supervisor Assigned");
      return;
    }

    const data = {
      selectedType,
      inputCredit,
      remarks,
      employee: { id: currentUser.employee.id },
      supervisor: allEmp[0].supervisor,
      stats: "Pending",
      createdBy: { id: currentUser.id },
    };
    // if (Object.keys(selectedFiles).length < 1) {
    //   this.showError(`Select atleast one attachment`);
    //   return;
    // }

    const emp = await findObjectUseCase().execute("employees", {
      where: { id: currentUser.employee.id },
      keys: ["email"],
    });
    const leave = await findObjectUseCase().execute("leave_cred", {
      where: { empID: emp[0].id, type: data.selectedType },
    });
    // console.log("DATA: ", data);
    // console.log("leave: ", leave);
    // console.log("emp: ", emp);
    // return;
    const SelectedFiles = await SubmitImg(selectedFiles);
    const newData = { selectedFiles: SelectedFiles, ...data };

    if (
      leave.length === 0 ||
      parseFloat(leave[0].current) < parseFloat(data.inputCredit)
    ) {
      this.showError("Insufficient Credit");
      return;
    }

    if (this.state.objectID !== "") {
      newData.id = this.state.objectID;
    }

    const monetizationRequest = await upsertUseCase().execute(
      "monetization_request",
      newData,
    );

    //  CREATE NOTIFICATION
    const NOTIFICATION_MESSAGE =
      "You have a Monetization Request awaiting review.";
    const NOTIFICATION_RECEIVER = [monetizationRequest.supervisor.id];
    const NOTIFICATION_REDIRECT = "leaves";

    createNotification(
      NOTIFICATION_MESSAGE,
      NOTIFICATION_RECEIVER,
      NOTIFICATION_REDIRECT,
    );

    this.props.closeTrainingForm();
    this.showSuccess("Success");
    this.props.refetchData();
  }

  render() {
    return (
      <>
        <FloatingForm width="30rem">
          <CardView style={{ padding: 0 }}>
            <h4 className="fs-6 fw-bold pt-3 ps-3">
              Request Leave Monetization
            </h4>
            <hr />
            <form
              onSubmit={(e) => {
                e.preventDefault();
                this.hanldeSubmit();
              }}
            >
              <div className="w-100 pt-3" style={{ padding: "0 1.5rem" }}>
                <div className="mb-4">
                  <label className="mb-2 fs-6">
                    Leave Type <span className="text-danger">*</span>
                  </label>
                  {/* <InputFactory
                    required
                    disabled={Object.keys(this.props.object).length > 0}
                    type="String"
                    // value={this.state.workingDays}
                    defaultValue={this.state.selectedType}
                    onChange={(value) =>
                      this.onChangeForm("selectedType", value)
                    }
                  /> */}
                  <SearchSelect
                    required
                    disabled={Object.keys(this.props.object).length > 0}
                    value={this.state.selectedType}
                    onClickClear={() => this.onChangeForm("selectedType", "")}
                    onChange={(value) =>
                      this.onChangeForm("selectedType", value)
                    }
                    options={this.state.type.map((type) => ({
                      label: type.name,
                      value: type.name,
                    }))}
                  />
                </div>
                <div className="d-grid">
                  <div>
                    <label className="mb-2 fs-6">
                      Input Credit <span className="text-danger">*</span>
                    </label>
                    <InputFactory
                      required
                      disabled={Object.keys(this.props.object).length > 0}
                      type="DecemalNum"
                      // value={this.state.workingDays}
                      defaultValue={this.state.inputCredit}
                      onChange={(value) =>
                        this.onChangeForm("inputCredit", value)
                      }
                    />
                  </div>

                  <div className="mb-2">
                    <label className="mb-2 fs-6">Attachments</label>
                    <br></br>
                    <InputFactory
                      type="File"
                      onChange={(val) =>
                        this.onChangeForm("selectedFiles", val)
                      }
                      disabled={Object.keys(this.props.object).length > 0}
                      value={this.state.selectedFiles}
                      className="form-control"
                    />
                  </div>

                  <div className="mb-4">
                    <label className="mb-2 fs-6">
                      Remarks <span className="text-danger">*</span>
                    </label>
                    <InputFactory
                      required
                      type="Text"
                      value={this.state.remarks}
                      onChange={(value) => this.onChangeForm("remarks", value)}
                      disabled={Object.keys(this.props.object).length > 0}
                    />
                  </div>
                </div>
              </div>
              <hr />
              <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
                <button
                  className="btn btn-light"
                  type="button"
                  onClick={() => this.props.closeTrainingForm()}
                >
                  Cancel
                </button>
                {!Object.keys(this.props.object).length > 0 && (
                  <button
                    className="btn btn-primary"
                    // onClick={this.hanldeSubmit.bind(this)}
                    type="submit"
                  >
                    Submit
                  </button>
                )}
              </div>
            </form>
          </CardView>
        </FloatingForm>
      </>
    );
  }
}
